import { IPathParamsArgs, numberArgs } from '@app/api/repositories/i-repository'
import organizationScheduleRepository from '@app/api/repositories/organization-schedule-repository'
import axios from 'axios'
import {
  CLEAR_ORGANIZATION_SCHEDULE,
  CLEAR_ORGANIZATION_SCHEDULES,
  CREATE_ORGANIZATION_SCHEDULE,
  FETCH_ORGANIZATION_SCHEDULES_FAILURE,
  FETCH_ORGANIZATION_SCHEDULES_REQUEST,
  FETCH_ORGANIZATION_SCHEDULES_SUCCESS,
  FETCH_ORGANIZATION_SCHEDULE_CLEANUP,
  FETCH_ORGANIZATION_SCHEDULE_FAILURE,
  FETCH_ORGANIZATION_SCHEDULE_REQUEST,
  FETCH_ORGANIZATION_SCHEDULE_SUCCESS,
  REFRESH_ORGANIZATION_SCHEDULE,
  UPDATE_ORGANIZATION_SCHEDULE,
} from '../types/organization-schedule'

export const getOrganizationSchedules =
  (args: IPathParamsArgs, message) => async (dispatch) => {
    dispatch(fetchOrganizationSchedulesRequest())
    await organizationScheduleRepository
      .getAll({ params: args.params, source: args.source })
      .then((response) => {
        dispatch(
          fetchOrganizationSchedulesSuccess(
            response.data,
            response.headers['x-total-count'],
          ),
        )
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          dispatch(
            fetchOrganizationSchedulesFailure(error?.message, error?.code),
          )
        }
      })
    fetchOrganizationScheduleCleanup()
  }

export const getOrganizationSchedule =
  (args: numberArgs, message) => async (dispatch) => {
    dispatch(fetchOrganizationScheduleRequest())
    await organizationScheduleRepository
      .getOne(args)
      .then((response) => {
        dispatch(fetchOrganizationScheduleSuccess(response.data))
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          dispatch(
            fetchOrganizationScheduleFailure(error?.message, error?.code),
          )
        }
      })
    fetchOrganizationScheduleCleanup()
  }

const fetchOrganizationSchedulesRequest = () => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULES_REQUEST,
  }
}

const fetchOrganizationSchedulesSuccess = (organizationSchedules, count) => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULES_SUCCESS,
    payload: { organizationSchedules, count },
  }
}

const fetchOrganizationSchedulesFailure = (message, code) => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULES_FAILURE,
    payload: { message, code },
  }
}

const fetchOrganizationScheduleRequest = () => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULE_REQUEST,
  }
}

const fetchOrganizationScheduleSuccess = (organizationSchedule) => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULE_SUCCESS,
    payload: organizationSchedule,
  }
}

const fetchOrganizationScheduleFailure = (message, code) => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULE_FAILURE,
    payload: { message, code },
  }
}

const fetchOrganizationScheduleCleanup = () => {
  return {
    type: FETCH_ORGANIZATION_SCHEDULE_CLEANUP,
  }
}

export function clearOrganizationSchedule() {
  return {
    type: CLEAR_ORGANIZATION_SCHEDULE,
  }
}

export function clearOrganizationSchedules() {
  return {
    type: CLEAR_ORGANIZATION_SCHEDULES,
  }
}

export function updateOrganizationSchedule(OrganizationSchedule) {
  return {
    type: UPDATE_ORGANIZATION_SCHEDULE,
    payload: OrganizationSchedule,
  }
}

export function createOrganizationSchedule(OrganizationSchedule) {
  return {
    type: CREATE_ORGANIZATION_SCHEDULE,
    payload: OrganizationSchedule,
  }
}

export function refreshOrganizationSchedule() {
  return {
    type: REFRESH_ORGANIZATION_SCHEDULE,
  }
}
